import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Chip } from '@material-ui/core'

import * as DoorAccessActionCreators from '../../actions/doorAccess'

class UnitAccessChipContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    accessId: PropTypes.number.isRequired,
    unitId: PropTypes.number.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    units: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
      units: state.units,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  static styles = (theme) => ({
    chip: {
      margin: theme.spacing(0.5),
    },
  })

  handleClick = (event) => {
    event.stopPropagation()
  }

  handleDelete = (event) => {
    event.stopPropagation()
    this.props.doorAccessActions.removeUnitDoorAccess(this.props.unitId, this.props.accessId)
  }

  getUnit = () => {
    const { units, unitId } = this.props
    return units[unitId] || {}
  }

  getUser = () => this.props.doorAccesses[this.props.accessId] || {}

  render() {
    return (
      <Chip
        className={this.props.classes.chip}
        clickable={false}
        color={this.getUser().enabled ? 'primary' : 'default'}
        label={this.getUnit().name || ''}
        onClick={this.handleClick}
        onDelete={this.handleDelete}
        variant="outlined"
      />
    )
  }
}

export default connect(
  UnitAccessChipContainer.mapStateToProps,
  UnitAccessChipContainer.mapDispatchToProps,
)(withStyles(UnitAccessChipContainer.styles)(UnitAccessChipContainer))
